import { LegalLayout } from './LegalLayout';

const LAST_UPDATED = '2026-10-05';

// Draft prepared by engineering from the current codebase behaviour, with the
// governing-law and arbitration terms set by the owner (2026-10-04). It has not
// been reviewed by counsel — do not treat it as final before that review
// happens and this comment is removed.
export function TermsPage() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated={LAST_UPDATED}>
      <section>
        <p>
          These terms govern your use of FewerBags (&ldquo;the service&rdquo;), operated by{' '}
          <strong>Five01 Creations</strong> (&ldquo;we&rdquo;, &ldquo;us&rdquo;) at{' '}
          <a href="https://fewerbags.com">fewerbags.com</a> and through the FewerBags mobile apps.
          By creating an account you agree to these terms. Questions go to{' '}
          <a href="mailto:support@five01creations.com">support@five01creations.com</a>.
        </p>
      </section>

      <section>
        <h2>The service</h2>
        <p>
          FewerBags helps a household plan meals, track a pantry, and build store-aware grocery
          lists. Your account belongs to one or more <strong>households</strong> — a small group you
          invite (family, roommates, etc.) who share recipes, meal plans, pantry state, and grocery
          lists with each other. Some recipe and ingredient data is shared more widely across all
          households using FewerBags, in aggregated or explicitly public form, as described in the
          Privacy Policy.
        </p>
      </section>

      <section>
        <h2>Household roles</h2>
        <p>
          Each household has one or more owners and may have other adult or general members. The
          owner(s) control who belongs to the household, what role they have, and can remove a
          member. If you are the sole owner of a household with other members, you'll need to
          transfer ownership to someone else before you can delete your own account.
        </p>
      </section>

      <section>
        <h2>Your content</h2>
        <p>
          You own the recipes, photos, and other content you add. By adding content to a shared or
          public area of the service (for example, marking a recipe public, or contributing a price,
          product, or ingredient photo to the shared catalog) you grant us and the households that
          rely on that catalog a licence to use, display, and aggregate it as part of running the
          service. You're responsible for having the right to share anything you upload. When you
          make a recipe public, you confirm that you have the right to share its text and photo, and
          you agree that we may remove it on receiving a valid complaint.
        </p>
      </section>

      <section>
        <h2>Acceptable use</h2>
        <p>You agree not to:</p>
        <ul>
          <li>
            upload content you don't have the right to share, or that infringes someone else's
            rights;
          </li>
          <li>
            upload unlawful, abusive, or otherwise objectionable content, especially to areas
            visible to other households;
          </li>
          <li>attempt to access another household's private data, or another user's account;</li>
          <li>
            abuse the recipe-import feature to fetch pages you don't have the right to fetch, or to
            attack another server;
          </li>
          <li>
            interfere with the service's operation (scraping at scale, denial-of-service,
            circumventing security controls).
          </li>
        </ul>
        <p>
          If you believe content on the service is inappropriate or violates these terms, contact{' '}
          <a href="mailto:support@five01creations.com">support@five01creations.com</a> and we'll
          review it; we may disable a household's account and exclude its contributions from the
          shared catalog while we do.
        </p>
      </section>

      <section>
        <h2>Account and data deletion</h2>
        <p>
          You can delete your account at any time from Settings. See the Privacy Policy for what
          deletion does and doesn't remove.
        </p>
      </section>

      <section>
        <h2>No warranty; limitation of liability</h2>
        <p>
          The service is provided &ldquo;as is&rdquo; and &ldquo;as available&rdquo;, without
          warranties of any kind, express or implied. We are not liable for indirect, incidental, or
          consequential damages arising from your use of the service, to the fullest extent the law
          allows.
        </p>
      </section>

      <section>
        <h2>Changes and termination</h2>
        <p>
          We may update these terms; if we do, we'll update the date at the top of this page.
          Continuing to use the service after a change means you accept the update. We may suspend
          or disable an account or household that violates these terms.
        </p>
      </section>

      <section>
        <h2>Governing law and dispute resolution</h2>
        <p>
          These terms are governed by the laws of the State of Florida, United States, without
          regard to its conflict-of-laws rules.
        </p>
        <p>
          <strong>Binding arbitration.</strong> Any dispute, claim, or controversy arising out of or
          relating to these terms or the service &mdash; including whether a dispute is subject to
          arbitration &mdash; will be resolved exclusively by final and binding arbitration, rather
          than in court. The arbitration will be administered by the American Arbitration
          Association under its Consumer Arbitration Rules, before a single arbitrator, in the State
          of Florida or by video conference, and judgment on the award may be entered in any court
          with jurisdiction. Each of us may instead bring an individual claim in small-claims court
          if it qualifies, and either of us may seek an injunction in court to protect intellectual
          property or to stop unauthorised use of the service.
        </p>
        <p>
          <strong>Individual basis.</strong> Disputes will be resolved on an individual basis only.
          Neither of us may bring or participate in a class, collective, or representative action,
          and the arbitrator may not consolidate claims of different users. By accepting these
          terms, you and Five01 Creations each give up the right to a trial by jury.
        </p>
        <p>
          You may opt out of this arbitration agreement by emailing{' '}
          <a href="mailto:support@five01creations.com">support@five01creations.com</a> within 30
          days of first accepting these terms; the rest of the terms still apply.
        </p>
      </section>
    </LegalLayout>
  );
}
